import React from 'react'
import { useDebouncedCallback } from 'use-debounce'
import {
  createMemberSelectorContext,
  MembersSelectorContext
} from '../MembersSelectorContext'
import { IMembersSelectorMembers } from '../MembersSelectors.types'
import { observer } from 'mobx-react-lite'
import { SyncState } from './SyncState'

const SEARCH_DEBOUNCE = 500

type WithMembersSelectorContextProps = {
  onQueryChange: (q: string) => void
  changeSelectedMembers: (state: IMembersSelectorMembers) => void
  selectedMembers: IMembersSelectorMembers
  addressBook?: IMembersSelectorMembers
  membersFound: IMembersSelectorMembers
}

export const WithMembersSelectorContext: React.FC<WithMembersSelectorContextProps> =
  observer(
    ({
      children,
      changeSelectedMembers,
      addressBook,
      onQueryChange,
      membersFound,
      selectedMembers
    }) => {
      const changeDebouncedQuery = useDebouncedCallback(
        onQueryChange,
        SEARCH_DEBOUNCE
      )

      const context = React.useMemo(
        () =>
          createMemberSelectorContext({
            selectedMembers,
            changeDebouncedQuery,
            changeSelectedMembers,
            addressBook,
            membersFound
          }),
        []
      )

      return (
        <MembersSelectorContext.Provider value={context}>
          <SyncState
            membersFound={membersFound}
            selectedMembers={selectedMembers}
            notifyParentOnChangeSelectedMembers={changeSelectedMembers}
            addressBook={addressBook}
          />
          {children}
        </MembersSelectorContext.Provider>
      )
    }
  )
